// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import AccountAnalyticsLogo from './AccountAnalyticsLogo';
import AddMember from './AddMember';
import Add from './Add';
import Airplane from './Airplane';
import Api from './Api';
import Backward from './Backward';
import Bolt from './Bolt';
import Calendar from './Calendar';
import CaretDown from './CaretDown';
import CaretLeft from './CaretLeft';
import CaretRight from './CaretRight';
import CaretUp from './CaretUp';
import Chart from './Chart';
import Clipboard from './Clipboard';
import Collapse from './Collapse';
import Copy from './Copy';
import CreditCard from './CreditCard';
import Discord from './Discord';
import Documentation from './Documentation';
import Door from './Door';
import Download from './Download';
import Drive from './Drive';
import Edgeworker from './Edgeworker';
import Edit from './Edit';
import ExclamationSign from './ExclamationSign';
import Expand from './Expand';
import ExternalLink from './ExternalLink';
import Eye from './Eye';
import Facebook from './Facebook';
import File from './File';
import Filter from './Filter';
import Firebolt from './Firebolt';
import FlowchartAlt from './FlowchartAlt';
import Flowchart from './Flowchart';
import Forward from './Forward';
import Gateway from './Gateway';
import Gear from './Gear';
import GitBranch from './GitBranch';
import Github from './Github';
import GooglePlus from './GooglePlus';
import Hamburger from './Hamburger';
import Happy from './Happy';
import Help from './Help';
import InfoSign from './InfoSign';
import Left from './Left';
import Link from './Link';
import Linkedin from './Linkedin';
import List from './List';
import Lock from './Lock';
import MagicTransitLogo from './MagicTransitLogo';
import Mail from './Mail';
import Minus from './Minus';
import More from './More';
import NetworkAnalyticsLogo from './NetworkAnalyticsLogo';
import Network from './Network';
import OkSign from './OkSign';
import Ok from './Ok';
import PagesLogo from './PagesLogo';
import Pause from './Pause';
import Plus from './Plus';
import Printer from './Printer';
import Refresh from './Refresh';
import RegistrarLogo from './RegistrarLogo';
import Remove from './Remove';
import Reorder from './Reorder';
import ResizeHorizontal from './ResizeHorizontal';
import Retarget from './Retarget';
import Revert from './Revert';
import Right from './Right';
import Sad from './Sad';
import Script from './Script';
import Search from './Search';
import Shield from './Shield';
import Spectrum from './Spectrum';
import Speech from './Speech';
import Stream from './Stream';
import Teams from './Teams';
import Time from './Time';
import Twitter from './Twitter';
import TwoWay from './TwoWay';
import Upload from './Upload';
import User from './User';
import Wasm from './Wasm';
import WebAnalyticsLogo from './WebAnalyticsLogo';
import WorkersLogo from './WorkersLogo';
import Wrench from './Wrench';
export default {
  'account-analytics-logo': AccountAnalyticsLogo,
  'add-member': AddMember,
  add: Add,
  airplane: Airplane,
  api: Api,
  backward: Backward,
  bolt: Bolt,
  calendar: Calendar,
  'caret-down': CaretDown,
  'caret-left': CaretLeft,
  'caret-right': CaretRight,
  'caret-up': CaretUp,
  chart: Chart,
  clipboard: Clipboard,
  collapse: Collapse,
  copy: Copy,
  'credit-card': CreditCard,
  discord: Discord,
  documentation: Documentation,
  door: Door,
  download: Download,
  drive: Drive,
  edgeworker: Edgeworker,
  edit: Edit,
  'exclamation-sign': ExclamationSign,
  expand: Expand,
  'external-link': ExternalLink,
  eye: Eye,
  facebook: Facebook,
  file: File,
  filter: Filter,
  firebolt: Firebolt,
  'flowchart-alt': FlowchartAlt,
  flowchart: Flowchart,
  forward: Forward,
  gateway: Gateway,
  gear: Gear,
  'git-branch': GitBranch,
  github: Github,
  'google-plus': GooglePlus,
  hamburger: Hamburger,
  happy: Happy,
  help: Help,
  'info-sign': InfoSign,
  left: Left,
  link: Link,
  linkedin: Linkedin,
  list: List,
  lock: Lock,
  'magic-transit-logo': MagicTransitLogo,
  mail: Mail,
  minus: Minus,
  more: More,
  'network-analytics-logo': NetworkAnalyticsLogo,
  network: Network,
  'ok-sign': OkSign,
  ok: Ok,
  'pages-logo': PagesLogo,
  pause: Pause,
  plus: Plus,
  printer: Printer,
  refresh: Refresh,
  'registrar-logo': RegistrarLogo,
  remove: Remove,
  reorder: Reorder,
  'resize-horizontal': ResizeHorizontal,
  retarget: Retarget,
  revert: Revert,
  right: Right,
  sad: Sad,
  script: Script,
  search: Search,
  shield: Shield,
  spectrum: Spectrum,
  speech: Speech,
  stream: Stream,
  teams: Teams,
  time: Time,
  twitter: Twitter,
  'two-way': TwoWay,
  upload: Upload,
  user: User,
  wasm: Wasm,
  'web-analytics-logo': WebAnalyticsLogo,
  'workers-logo': WorkersLogo,
  wrench: Wrench
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/index.js
// module id = 978
// module chunks = 0